import React, {ReactNode} from 'react';
import {useKeycloak} from './useKeycloak';

interface RoleBasedAccessProps {
    roles: string | string[];
    resource?: string;
    forbiddenFallback?: ReactNode;
    children: ReactNode;
}

/**
 * Componente para controle de acesso baseado em roles
 * @param roles - Role ou array de roles requeridas
 * @param resource - (Opcional) Cliente específico para verificar resource roles
 * @param forbiddenFallback - (Opcional) Componente a ser mostrado quando o acesso é negado
 */
export const RoleBasedAccess: React.FC<RoleBasedAccessProps> = ({
                                                                    roles,
                                                                    resource,
                                                                    forbiddenFallback = null,
                                                                    children
                                                                }) => {
    const {hasRole, hasResourceRole} = useKeycloak();
    const rolesToCheck = Array.isArray(roles) ? roles : [roles];

    // Se um resource específico for fornecido, verifica apenas nesse cliente
    if (resource) {
        const hasAccess = rolesToCheck.some(role => hasResourceRole(role, resource));
        return hasAccess ? <>{children}</> : <>{forbiddenFallback}</>;
    }

    // Caso contrário, verifica se o usuário tem qualquer uma das roles
    const hasAccess = hasRole(rolesToCheck);
    return hasAccess ? <>{children}</> : <>{forbiddenFallback}</>;
};